import { defineMessages } from 'react-intl';

const messages = defineMessages({
  orderSummaryHeader: {
    id: 'Uo9+sO',
    defaultMessage: 'Order Summary',
    description: 'Header title for Order details side panel order summary section',
  },
  informationBanner: {
    id: 'v7mYGl',
    defaultMessage:
      'The information listed summarizes the order sent from your {marketplaceName} store. Any updates from the store will be reflected here.',
    description: 'Informational banner describing the content of the order summary',
  },
  shipToLabel: {
    id: '+6Twa5',
    defaultMessage: 'Ship To Address',
    description: 'Label for ship to address in order summary',
  },
  productTotalLabel: {
    id: 'ueNNO7',
    defaultMessage: 'Product',
    description: 'Label for product total field in order summary',
  },
  taxPaidLabel: {
    id: 'k1T9SB',
    defaultMessage: 'Tax',
    description: 'Label for tax paid field in order summary',
  },
  shippingPaidLabel: {
    id: 'oWeYHQ',
    defaultMessage: 'Shipping',
    description: 'Label for shipping paid field in order summary',
  },
  totalPaidLabel: {
    id: 'LWeOty',
    defaultMessage: 'Total Paid',
    description: 'Label for total paid field in order summary',
  },
  orderTotalLabel: {
    id: 'Dcp+pa',
    defaultMessage: 'Order Total',
    description: 'Label for order total field in order summary',
  },
  shipByDateLabel: {
    id: 'HrET3F',
    defaultMessage: 'Ship By',
    description: 'Order summary ship by date label',
  },
  orderDateLabel: {
    id: 'IQ3WcP',
    defaultMessage: 'Order Date',
    description: 'Order summary order date label',
  },
  paidDateLabel: {
    id: 'xA7SdT',
    defaultMessage: 'Paid Date',
    description: 'Order summary paid date label',
  },
  soldToLabel: {
    id: '3tyP6m',
    defaultMessage: 'Sold To',
    description: 'Order summary sold to field label',
  },
  taxInformationLabel: {
    id: 'cvD6rn',
    defaultMessage: 'Tax Information',
    description: 'Order summary tax information field label',
  },
  orderItemsNameColumnLabel: {
    id: 'ucmIKB',
    defaultMessage: 'Item Name',
    description: 'Order items table name column label',
  },
  orderItemsQuantityColumnLabel: {
    id: 'S/VIvM',
    defaultMessage: 'Quantity',
    description: 'Order items table quantity column label',
  },
  orderNumberLabel: {
    id: 'ux59z/',
    defaultMessage: 'Order #',
    description: 'Label for order number field in order summary',
  },
  orderNumberAriaLabel: {
    id: 'GzFwvx',
    defaultMessage: 'link to this orders external store. Link opens in a new window.',
    description: 'arial label describing a link that opens in another window',
  },
  orderDetails: {
    id: 'GqVsii',
    defaultMessage: 'Order Details',
    description: 'header label for collapsible Order Details section',
  },
  orderItems: {
    id: 'j9PE0i',
    defaultMessage: 'Order Items',
    description: 'header label for collapsible Order Items section',
  },
  orderItemsCount: {
    id: 'zXLQpi',
    defaultMessage: '{salesOrderItemCount} items',
    description: 'order items count, displayed in the header of the order items section of order summary',
  },
  orderItemsEmptyOrder: {
    id: 'vKJf0N',
    defaultMessage: 'You have no items in this order',
    description: 'message informing the user there are not items in the current order',
  },
  orderDetailsSectionLabel: {
    defaultMessage: 'Order Details Expander Section',
    description: 'Label for order details section',
    id: 'e4me3S',
  },
  orderItemsSectionLabel: {
    defaultMessage: 'Order Items Expander Section',
    description: 'Label for order items section',
    id: 'uUBbth',
  },
});

export default messages;
